module.exports = __webpack_public_path__ + "5aafba2503ca248959fa7c09a19d6b88.png";